import {
  FETCH_LIST_INTEGRATION,
  SAVE_INTEGRATION,
  FETCH_INTEGRATION_BY_ID,
  DELETE_INTEGRATION,
} from '../constants/constant_integration';

export function fetchIntegrationList(silent, filters) {
  return { type: FETCH_LIST_INTEGRATION, silent, filters };
}

export function saveIntegration(data) {
  return { type: SAVE_INTEGRATION, data };
}

export function fetchIntegrationById(id) {
  return { type: FETCH_INTEGRATION_BY_ID, id };
}

export function deleteIntegration(id) {
  return { type: DELETE_INTEGRATION, id };
}
